import Config from '@interface/config';

export default {
  redocSpecUrl: 'https://api.adthena.com/application/openapi.yaml'
} as Config;
